import { Dispatch } from "redux";
import { toast } from "react-toastify";
import FetchAPI from "../../api/FetchAPI";
import {
  FETCH_APPS_FAILURE,
  FETCH_APPS_SUCCESS,
  FETCH_DEPLOYMENT_TYPES_FAILURE,
  FETCH_DEPLOYMENT_TYPES_SUCCESS,
  SET_ERROR_MESSAGE,
  SET_FORM_DATA,
  SET_FORM_ERRORS,
  SET_SAVE_CREDENTIALS,
  SET_SELECTED_APP,
  SET_SELECTED_DEPLOYMENT_TYPE,
  RESET_FORM,
  FETCH_CATEGORIES_FAILURE,
  FETCH_CATEGORIES_SUCCESS,
} from "./constants";
import {
  MarketplaceAppItem,
  MarketplaceActionTypes,
  MarketplaceCategory,
} from "../types";

export const fetchApps = () => async (dispatch: Dispatch) => {
  try {
    const response = await FetchAPI.Marketplace.fetchMarketplaceApps();
    dispatch({ type: FETCH_APPS_SUCCESS, payload: response });
  } catch (error) {
    console.error(error);
    dispatch({ type: FETCH_APPS_FAILURE });
    toast.error("Failed to fetch apps.");
  }
};

export const fetchDeploymentTypes =
  (appId: number) => async (dispatch: Dispatch) => {
    try {
      const response = await FetchAPI.Marketplace.fetchDeploymentTypes(appId);
      dispatch({ type: FETCH_DEPLOYMENT_TYPES_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: FETCH_DEPLOYMENT_TYPES_FAILURE });
      toast.error("Failed to fetch deployment types.");
    }
  };

export const fetchCategories = () => async (dispatch: Dispatch) => {
  try {
    const response: MarketplaceCategory[] =
      await FetchAPI.Marketplace.fetchMarketplaceCategories();
    dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: response });
  } catch (error) {
    console.error(error);
    dispatch({ type: FETCH_CATEGORIES_FAILURE });
    toast.error("Failed to fetch categories.");
  }
};
export const setSelectedApp = (
  app: MarketplaceAppItem | null,
): MarketplaceActionTypes => ({
  type: SET_SELECTED_APP,
  payload: app,
});

export const setSelectedDeploymentType = (
  deploymentType: number | null,
): MarketplaceActionTypes => ({
  type: SET_SELECTED_DEPLOYMENT_TYPE,
  payload: deploymentType,
});

export const setFormData = (
  data: Record<string, any>,
): MarketplaceActionTypes => ({
  type: SET_FORM_DATA,
  payload: data,
});

export const setSaveCredentials = (
  saveCredentials: boolean,
): MarketplaceActionTypes => ({
  type: SET_SAVE_CREDENTIALS,
  payload: saveCredentials,
});

export const setFormErrors = (
  errors: Record<string, any>,
): MarketplaceActionTypes => ({
  type: SET_FORM_ERRORS,
  payload: errors,
});

export const setErrorMessage = (message: string): MarketplaceActionTypes => ({
  type: SET_ERROR_MESSAGE,
  payload: message,
});

export const resetFormAction = (): MarketplaceActionTypes => ({
  type: RESET_FORM,
});
